import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CustomPointOfService } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { CityActions } from '../store/actions';
import { StateWithCity } from '../store/city-state';
import { CitySelectors } from '../store/selectors';
import { BaseStoreFacade } from './base-store.facade';

@Injectable({
  providedIn: 'root',
})
export class BaseStoreShopsFacade {
  activeBaseStoreShops$: Observable<CustomPointOfService[]> = this.baseStoreFacade.getActiveCode().pipe(
    switchMap((code) =>
      this.getBaseStoreShopsState(code).pipe(
        tap(({ loading, success, error }) => {
          if (!loading && !success && !error) {
            this.loadBaseStoreShops(code);
          }
        }),
      ),
    ),
    filter(({ error, success }) => Boolean(error || success)),
    map(({ value }) => value || []),
  );

  constructor(
    private store: Store<StateWithCity>,
    private baseStoreFacade: BaseStoreFacade,
  ) {}

  private loadBaseStoreShops(code: string): void {
    this.store.dispatch(new CityActions.LoadBaseStoreShops(code));
  }

  private getBaseStoreShopsState(code: string): Observable<StateUtils.LoaderState<CustomPointOfService[]>> {
    return this.store.pipe(select(CitySelectors.getBaseStoreShopsEntityState(code)));
  }
}
